<template>
  <div v-if="loading" class="loading">
    <img src="@/assets/icon/loading.svg" alt="" class="rotate-scale-up">
  </div>
</template>

<script>
export default {
  name: 'Loading',
  data: () => ({
    loading: false
  }),
  methods: {
    start () {
      this.loading = true
    },
    finish () {
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
  .loading {
    position: fixed;
    left: 0;
    top: 0;
    min-height: 100vh;
    width: 100%;
    z-index: 9999999;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255,255,255,.8);

    img {
      width: 80px;
    }
  }

  .rotate-scale-up {
    -webkit-animation: rotate-scale-up 4s linear infinite both;
    animation: rotate-scale-up 4s linear infinite both;
  }

  @-webkit-keyframes rotate-scale-up {
    0% {
      -webkit-transform: scale(1) rotateZ(0);
      transform: scale(1) rotateZ(0);
    }
    50% {
      -webkit-transform: scale(1.2) rotateZ(180deg);
      transform: scale(1.2) rotateZ(180deg);
    }
    100% {
      -webkit-transform: scale(1) rotateZ(360deg);
      transform: scale(1) rotateZ(360deg);
    }
  }
  @keyframes rotate-scale-up {
    0% {
      -webkit-transform: scale(1) rotateZ(0);
      transform: scale(1) rotateZ(0);
    }
    50% {
      -webkit-transform: scale(1.2) rotateZ(180deg);
      transform: scale(1.2) rotateZ(180deg);
    }
    100% {
      -webkit-transform: scale(1) rotateZ(360deg);
      transform: scale(1) rotateZ(360deg);
    }
  }
</style>
